
import { cn } from "../lib/utils";

export function Error( { className, ...props } ) {

  return (

    <p className={ cn( "text-sm text-red mb-1", className ) } { ...props } />

  )

}
